import {
  U21Button,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styled from 'styled-components';
import { FLOW_STATUS_LABELS } from 'app/modules/ruleFlows/components/FlowStatusChip';
import { RuleFlowStatus } from 'app/modules/ruleFlows/models';

interface Props {
  id: number | string;
  title: string;
  status: RuleFlowStatus;
}

const getFlowStatusLabel = (status: RuleFlowStatus): string => {
  if (status in FLOW_STATUS_LABELS) {
    return FLOW_STATUS_LABELS[status];
  }
  return status;
};

export const FlowTooltip = ({ id, title, status }: Props) => {
  return (
    <U21Spacer spacing={0}>
      <U21Spacer align="start" horizontal>
        <StyledTypography color="inherit" variant="body2">
          Name:
        </StyledTypography>
        <U21Typography breakWord color="inherit" variant="body2">
          {title}
        </U21Typography>
      </U21Spacer>
      <U21Spacer align="start" horizontal>
        <StyledTypography color="inherit" variant="body2">
          Status:
        </StyledTypography>
        <U21Typography color="inherit" variant="body2">
          {getFlowStatusLabel(status)}
        </U21Typography>
      </U21Spacer>
      <U21Spacer align="start" horizontal>
        <StyledTypography color="inherit" variant="body2">
          ID:
        </StyledTypography>
        <U21Spacer horizontal spacing={4}>
          <U21Typography color="inherit" variant="body2">
            {id}
          </U21Typography>
          <CopyToClipboard text={String(id)}>
            <U21Button variant="text" onClick={(e) => e.stopPropagation()}>
              Copy ID
            </U21Button>
          </CopyToClipboard>
        </U21Spacer>
      </U21Spacer>
    </U21Spacer>
  );
};

const StyledTypography = styled(U21Typography)`
  min-width: 50px;
  justify-content: flex-end;
`;
